import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getDatabase } from 'firebase/database';

// Firebase 설정
const firebaseConfig = {
  apiKey: "AIzaSyAsbhfY6vduXSV4UOe0dwWq1n4pfiVpY0Q",
  authDomain: "talkie-chat-202506.firebaseapp.com",
  projectId: "talkie-chat-202506",
  storageBucket: "talkie-chat-202506.firebasestorage.app",
  messagingSenderId: "277767913431",
  appId: "1:277767913431:web:4f82bd3f0c43c9d2c29592"
};

// Firebase 초기화
const app = initializeApp(firebaseConfig);

// Auth와 Firestore 인스턴스 생성
export const auth = getAuth(app);
export const db = getFirestore(app);
export const rtdb = getDatabase(app); // Realtime Database 인스턴스

export default app; 